<span [class.positive]="delta >= 0" [class.negative]="delta < 0">
  <i class="ui icon arrow" [class.up]="delta >= 0" [class.down]="delta < 0"></i>
  {{ delta | number: '1.0-2' }}<ng-template [ngIf]="showPercentSign">%</ng-template>
</span>
